// extracted by mini-css-extract-plugin
export var cdCcContent = "centered-content-module--cd-cc-content--59b3c";
export var cdCcSection = "centered-content-module--cd-cc-section--2375f";